import { MapTo } from '@adobe/aem-react-editable-components';
import ProductPageFees, { ProductPageFeesEditConfig } from './ProductPageFees';

export default MapTo('cob-corp-acquisition/components/creditonebank/product-page-fees')(ProductPageFees, ProductPageFeesEditConfig);